/**
 * Picks the single "best" nav match from a menu section (longest path wins, /sales index is special).
 */
export function getActiveMenuPath(location: string, itemPaths: string[]): string | null {
  const paths = Array.from(new Set(itemPaths))
    .filter((p) => p.length > 0)
    .sort((a, b) => b.length - a.length);
  for (const p of paths) {
    if (p === "/sales") {
      if (/^\/sales\/?$/.test(location)) return "/sales";
      continue;
    }
    if (p === "/") {
      if (location === "" || location === "/" || location === "/dashboard") return "/";
      continue;
    }
    if (location === p) return p;
    if (location.startsWith(p + "/")) return p;
  }
  return null;
}

export function isItemActiveInSet(itemPath: string, location: string, sectionPaths: string[]) {
  return getActiveMenuPath(location, sectionPaths) === itemPath;
}
